import { z } from 'zod'

export const schema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  slug: z.string(),
  tourismRegistrationNumber: z.string().nullable(),
  address: z.string(),
  postalCode: z.string(),

  village: z.object({
    name: z.string(),
    slug: z.string(),
  }),

  province: z.object({
    name: z.string(),
    slug: z.string(),
    url: z.string(),
  }),

  region: z.object({
    name: z.string(),
    slug: z.string(),
  }),

  latitude: z.number(),
  longitude: z.number(),
  directions: z.string().nullable(),

  pointsOfInterest: z.string().nullable(),

  owner: z.object({
    id: z.string(),
  }),

  media: z.array(
    z.object({
      url: z.string(),
      type: z.union([z.literal('PHOTO'), z.literal('VIDEO')]), // TODO: should be an enum
      alt: z.string(),
      width: z.number().int().nullable(),
      height: z.number().int().nullable(),
    }),
  ),

  calendarUpdate: z
    .object({
      daysSinceLastUpdate: z.number().int(),
      updatedAt: z.string(), // TODO: not used
    })
    .nullable(),

  features: z.object({
    languages: z.array(
      z.object({
        id: z.number().int(),
        name: z.string(),
        slug: z.string(),
      }),
    ),
    exteriors: z.array(
      z.object({
        id: z.number().int(),
        name: z.string(),
        slug: z.string(),
      }),
    ),
    interiors: z.array(
      z.object({
        id: z.number().int(),
        name: z.string(),
        slug: z.string(),
      }),
    ),
    services: z.array(
      z.object({
        id: z.number().int(),
        name: z.string(),
        slug: z.string(),
      }),
    ),
    accessibilities: z.array(
      z.object({
        id: z.number().int(),
        name: z.string(),
        slug: z.string(),
      }),
    ),
    situations: z.array(
      z.object({
        id: z.number().int(),
        name: z.string(),
        slug: z.string(),
      }),
    ),
    qualityCertifications: z.array(
      z.object({
        id: z.enum([
          'Q-QUALITY',
          'ONE_STAR',
          'TWO_STARS',
          'TREE_STARS',
          'FOUR_STARS',
          'FIVE_STARS',
        ]),
        name: z.string(),
        slug: z.string(),
      }),
    ),
  }),

  activityDetail: z.object({
    description: z.string().nullable(),
    activityGroups: z.array(
      z.object({
        id: z.number().int(),
        name: z.string(),
        slug: z.string(),
        activities: z.array(
          z.object({
            id: z.number().int(),
            name: z.string(),
            slug: z.string(),
          }),
        ),
      }),
    ),
  }),

  averagePriceAmount: z.object({
    amount: z.number().int(),
    currency: z.string(),
  }),

  rentType: z.enum(['ROOMS', 'FULL', 'BOTH']),
  numRooms: z.number().int(),
  numBeds: z.number().int(),
  capacity: z.object({
    min: z.number().int().nullable(),
    max: z.number().int(),
  }),

  review: z.object({
    totalReviews: z.number().int(),
    averageReviews: z.number(),
  }),
  salesService: z.object({
    isOnlineBookingActive: z.boolean(),
    isAllowedToShowPhone: z.boolean(),
    isAllowedToShowWhatsapp: z.boolean(),
    isAllowedToShowTravelerPhone: z.boolean(),
    isAllowedToShowTravelerEmail: z.boolean(),
    isAllowedToShowVideos: z.boolean(),
    isShowRecommendedCottage: z.boolean(),
    isShowExternalLinks: z.boolean(),
  }),
  externalLinks: z.object({
    website: z.string().nullable(),
    facebook: z.string().nullable(),
    instagram: z.string().nullable(),
    twitter: z.string().nullable(),
  }),
  registrationNumbers: z
    .array(
      z.object({
        name: z.string(),
        number: z.string(),
      }),
    )
    .optional(), // TODO: Este optional podría desaparecer en el futuro, cuando los cambios del endpoint estén listos
  isReviewsEnabled: z.boolean(),
})

export type schemaType = z.infer<typeof schema>
